import {API_HOST, API_URL} from "../../constants/axios";
import axios from "axios";
import {fetchApi} from "../fetch";

const instance = axios.create({
    baseURL: API_HOST,
});

export const loginUser = async (data) => {
    try {
        return await instance.post(API_URL.LOGIN, data);
    } catch (e) {
        return e.response;
    }
};

export const kakaoLogin = async (type) => {
    const res = await instance.get(API_URL.ACCOUNT_KAKAO_AUTHORIZE + `?type=${type}`)
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
}

export const joinUserInfo = async (name, userId, password, phoneNumber) => {
    try {
        return await instance.post(API_URL.ACCOUNT_JOIN, {
            name: name,
            userId: userId,
            password: password,
            phoneNumber: phoneNumber
        });
    } catch (e) {
        return e.response;
    }
};
export const idCheck = async (userId) => {
    try {
        return await instance.get(API_URL.ACCOUNT_ID_CHECK + `?id=${userId}`);
    } catch (e) {
        return e.response;
    }
};

export const codeAuthorization = async (phoneNumber) => {
    try {
        return await instance.post(API_URL.KAKAO_AUTHORIZATION + `?phoneNumber=${phoneNumber}`);
    } catch (e) {
        return e.response;
    }
};

export const postFindIdAuthCode = async (phoneNumber) => {
    const res = await instance.post(API_URL.ACCOUNT_FIND_ID, {
        phoneNumber: phoneNumber
    })
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
}

export const postFindIdGet = async (phoneNumber) => {
    const res = await instance.post(API_URL.ACCOUNT_FIND_ID_RES, {
        phoneNumber: phoneNumber
    })
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
}

export const postFindPwdAuthCode = async (id, phoneNumber) => {
    const res = await instance.post(API_URL.ACCOUNT_FIND_PWD, {
        id: id,
        phoneNumber: phoneNumber
    })
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
}

export const postFindPwdAuthorization = async (id, authCode) => {
    const res = await instance.post(API_URL.ACCOUNT_FIND_PWD_RES, {
        id: id,
        authCode: authCode
    })
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
}

export const postChangePassword = async (id, password) => {
    const res = await instance.post(API_URL.ACCOUNT_CHANGE_PWD, {
        id: id,
        password: password
    })
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
}